(() => {
  const SELECTOR = '[data-ti-rail-carousel]';

  const initBrandLoop = (root) => {
    const rail = root.querySelector('[data-ti-rail]');
    const previousButton = root.querySelector('[data-ti-rail-prev]');
    const nextButton = root.querySelector('[data-ti-rail-next]');

    if (!rail) return;

    previousButton?.setAttribute('hidden', '');
    nextButton?.setAttribute('hidden', '');

    const brands = Array.from(rail.children);
    if (brands.length < 2) return;

    const track = document.createElement('div');
    track.className = 'ti-brand-strip__track';
    track.setAttribute('role', 'presentation');
    track.style.setProperty('--ti-brand-loop-duration', `${Math.max(32, brands.length * 3.8)}s`);

    brands.forEach((brand) => track.appendChild(brand));

    brands.forEach((brand) => {
      const clone = brand.cloneNode(true);
      clone.classList.add('ti-brand-strip__brand--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.removeAttribute('role');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    });

    rail.appendChild(track);
    rail.classList.add('is-looping');
  };

  const initRailCarousel = (root) => {
    if (!root || root.dataset.tiRailReady === 'true') return;

    root.dataset.tiRailReady = 'true';

    if (root.hasAttribute('data-ti-brand-loop')) {
      initBrandLoop(root);
      return;
    }

    const rail = root.querySelector('[data-ti-rail]');
    const previousButton = root.querySelector('[data-ti-rail-prev]');
    const nextButton = root.querySelector('[data-ti-rail-next]');

    if (!rail || !previousButton || !nextButton) return;

    const isRtl = () => getComputedStyle(rail).direction === 'rtl';
    const maxScroll = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
    const currentPosition = () => (isRtl() ? Math.abs(rail.scrollLeft) : rail.scrollLeft);

    const getStep = () => {
      const firstItem = rail.firstElementChild;
      if (!firstItem) return rail.clientWidth * 0.8;

      const styles = getComputedStyle(rail);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstItem.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maximum = maxScroll();
      const hasOverflow = maximum > 2;

      previousButton.hidden = !hasOverflow;
      nextButton.hidden = !hasOverflow;

      if (!hasOverflow) return;

      const position = currentPosition();
      previousButton.disabled = position <= 2;
      nextButton.disabled = position >= maximum - 2;
    };

    const move = (direction) => {
      const logicalDirection = isRtl() ? -direction : direction;
      rail.scrollBy({ left: logicalDirection * getStep(), behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', () => requestAnimationFrame(updateControls), { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(rail);
    } else {
      window.addEventListener('resize', updateControls, { passive: true });
    }

    requestAnimationFrame(updateControls);
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) initRailCarousel(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initRailCarousel);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
